import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Main from "../pages/Main";
import AppBreadcrumbs from "./ui/AppBreadcrumbs";
import {
  fetchSettlementCharge,
  fetchSingleSettalmentAccount,
  withdrawSettlementBalance,
} from "../api/settalmentApi";
import { useWallet } from "../context/walletContext";
import { useSelector } from "react-redux";
import { formatAmount } from "../utils/formatAmount";

import { useNotify } from "../context/NotifyContext";

const statusLabel = {
  verified: "VERIFIED",
  pending_upload: "PENDING DOCUMENT UPLOAD",
  pending_verification: "UNDER VERIFICATION",
  deactivated: "DEACTIVATED",
  unknown: "pending",
};


const MoneyTransfer = () => {
  const {notify} = useNotify();
  const { id } = useParams();
  const navigate = useNavigate();
  const { walletAmt } = useWallet();
  const { userInfo } = useSelector((state) => state?.auth);

  const [settalmentSingleAcc, setSingleSettalmentAcc] = useState({});
  const [amount, setTransactionAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [settlementCharge, setSettlementCharge] = useState(1);
  const [chargeLoaded, setChargeLoaded] = useState(false);

  // ------------------- FETCH SINGLE ACCOUNT -------------------
  const fetch_settalmentAcc = async (id) => {
    try {
      const result = await fetchSingleSettalmentAccount(id);
      if (result?.success) {
        setSingleSettalmentAcc(result?.data?.settlementAcc || {});
      } else {
        notify(result?.message || "Failed to fetch account", "error");
      }
    } catch (err) {
      notify("Server Error. Try again later", "error");
    }
  };

  useEffect(() => {
    if (id) fetch_settalmentAcc(id);
  }, [id]);

  useEffect(() => {
    let active = true;
    fetchSettlementCharge()
      .then((result) => {
        if (!active) return;
        if (result?.success && Number.isFinite(Number(result.data?.charge))) {
          setSettlementCharge(Number(result.data.charge));
          setChargeLoaded(true);
        } else {
          notify(result?.message || "Could not load settlement charge", "error");
        }
      })
      .catch(() => {
        if (active) notify("Could not load settlement charge", "error");
      });

    return () => {
      active = false;
    };
  }, [notify]);

  // ------------------- AMOUNT CHANGE -------------------
  // const handleChange = (e) => {
  //   let value = e.target.value;

  //   // Allow only numbers with 2 decimal places
  //   if (!/^\d*\.?\d{0,2}$/.test(value)) return;

  //   // Prevent over-transfer
  //   const balance = walletAmt?.addMoney?.balance || 0;
  //   if (Number(value) > balance) value = balance;

  //   setTransactionAmount(value);
  // };

  // // ------------------- SUBMIT -------------------
  // const handleSubmit = async () => {
  //   // ------------------- VALIDATIONS -------------------
  //   if (!settalmentSingleAcc?.accountNumber || !settalmentSingleAcc?.ifsc) {
  //     return notify("Bank account details are invalid", "error");
  //   }

  //   if (!id) return notify("Settlement ID is invalid", "error");

  //   const amt = Math.floor(Number(amount));
  //   if (!amt || amt <= 0) return notify("Enter a valid whole-rupee amount", "error");

  //   const balance = walletAmt?.addMoney?.balance || 0;
  //   if (amt > balance) return notify("Amount exceeds wallet balance", "error");

  //   setLoading(true);

  //   try {
  //     const payload = {
  //       settlementId: id,
  //       amount: amt,
  //     };
  //     const res = await withdrawSettlementBalance(payload);
  //     if (res?.success) {
  //       notify(res?.message || "Transaction initiated", "success");
  //       const url =
  //         res?.data?.redirectionUrl ||
  //         res?.redirectionUrl ||
  //         res?.data?.redirectUrl;
  //       if (url) {
  //         window.location.href = url;
  //         return;
  //       }
  //       navigate("/money-settlement");
  //     } else {
  //       notify(res?.message || "Transaction failed", "error");
  //     }
  //   } catch (err) {
  //     notify("Server Error. Try again later", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const MIN_WITHDRAWAL = 100;
const MIN_WALLET_BALANCE = 100;

const getMaxWithdrawable = () => {
  const balance = Number(walletAmt?.addMoney?.balance || 0);

  return Math.max(
    0,
    balance - settlementCharge - MIN_WALLET_BALANCE
  );
};

// ------------------- AMOUNT CHANGE -------------------
const handleChange = (e) => {
  let value = e.target.value;

  if (!/^\d*\.?\d{0,2}$/.test(value)) return;

  const balance = Number(
    walletAmt?.addMoney?.balance || 0
  );

  const maxWithdrawable =
    balance -
    settlementCharge -
    MIN_WALLET_BALANCE;

  if (Number(value) > maxWithdrawable) {
    value = maxWithdrawable > 0
      ? String(maxWithdrawable)
      : "";
  }

  setTransactionAmount(value);
};

// ------------------- SUBMIT -------------------
const handleSubmit = async () => {
  if (
    !settalmentSingleAcc?.accountNumber ||
    !settalmentSingleAcc?.ifsc
  ) {
    return notify(
      "Bank account details are invalid",
      "error"
    );
  }

  if (!id) {
    return notify(
      "Settlement ID is invalid",
      "error"
    );
  }

  const amt = Math.floor(Number(amount));

  if (!amt || amt < MIN_WITHDRAWAL) {
    return notify(
      `Minimum withdrawal amount is ₹${MIN_WITHDRAWAL}`,
      "error"
    );
  }

  const balance = Number(
    walletAmt?.addMoney?.balance || 0
  );

  const requiredBalance =
    amt +
    settlementCharge +
    MIN_WALLET_BALANCE;

  if (balance < requiredBalance) {
    return notify(
      `You need at least ₹${requiredBalance} wallet balance to withdraw ₹${amt}`,
      "error"
    );
  }

  setLoading(true);

  try {
    const payload = {
      settlementId: id,
      amount: amt,
    };

    const res = await withdrawSettlementBalance(payload);

    if (res?.success) {
      notify(
        res?.message || "Transaction initiated",
        "success"
      );

      const url =
        res?.data?.redirectionUrl ||
        res?.redirectionUrl ||
        res?.data?.redirectUrl;

      if (url) {
        window.location.href = url;
        return;
      }

      navigate("/money-settlement");
    } else {
      notify(
        res?.message || "Transaction failed",
        "error"
      );
    }
  } catch (err) {
    notify(
      "Server Error. Try again later",
      "error"
    );
  } finally {
    setLoading(false);
  }
};



const isTransferAllowed = settalmentSingleAcc?.verified && settalmentSingleAcc?.isActive;



  return (
    <Main showRightPanel={false}>
      <div className="mt-4 font-[Poppins]">
        {/* BREADCRUMBS */}
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "MATM Module" },
            { label: "Settlements" },
          ]}
        />

        {/* WALLET BALANCE */}
        <div className="ds-card p-2 mb-4 mt-4 flex flex-wrap md:flex-nowrap items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <img
              src={`${userInfo?.logo}`}
              alt="profile"
              className="h-10 w-10 rounded-md object-cover"
            />
            <div className="flex flex-col md:flex-row md:items-center md:gap-2 whitespace-nowrap">
              <p className="text-[15px] font-semibold text-[var(--text-dark)]">{userInfo?.name}</p>
              <p className="hidden md:block text-[18px] font-semibold text-[var(--text-muted)]">|</p>
              <p className="text-[12px] md:text-[15px] font-semibold text-[var(--text-dark)]">
                ID: {userInfo?.userName || "12542697"}
              </p>
            </div>
          </div>
          <div className="text-right font-semibold text-[10px] md:text-[15px] leading-tight w-full md:w-auto text-[var(--text-dark)]">
            ADD MONEY WALLET BALANCE :
            <span className="text-[var(--error-color)] font-bold ml-1 text-[14px] md:text-[16px]">
              ₹ {formatAmount(walletAmt?.addMoney?.balance)}
            </span>
          </div>
        </div>

        {/* TRANSFER FORM */}
        <div className="ds-card p-6">
<div className="border-b border-[var(--border-color)] pb-2 mb-5">
  <h2 className="text-[15px] sm:text-xl font-semibold text-[var(--text-dark)]">
    Money Transfer Details
  </h2>

  <span className="block text-[11px] sm:text-xs text-[var(--text-muted)] mt-1 text-red-700">
    Min withdrawal ₹100 • ₹{formatAmount(settlementCharge)} settlement charge • Keep ₹100 minimum wallet balance
  </span>
</div>


          <p className="text-sm text-[var(--text-muted)] mb-2">{statusLabel[settalmentSingleAcc?.status] || "pending"}</p>

{!isTransferAllowed && (
  <div className="bg-[var(--warning-color)]/15 text-[var(--warning-color)] border border-[var(--warning-color)]/30 p-2 rounded text-sm mb-3">
    ⚠ Bank account is not verified. Transfer is disabled.
  </div>
)}



          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* ACCOUNT HOLDER */}
            <div className="flex flex-col">
              <label className="ds-label">
                ACCOUNT HOLDER NAME <span className="text-[var(--error-color)]">*</span>
              </label>
              <input
                type="text"
                value={settalmentSingleAcc.accountHolderName || ""}
                disabled
                className="ds-input bg-[var(--bg-app)] cursor-not-allowed"
              />
            </div>

            {/* BANK NAME */}
            <div className="flex flex-col">
              <label className="ds-label">
                BANK NAME <span className="text-[var(--error-color)]">*</span>
              </label>
              <input
                type="text"
                value={settalmentSingleAcc.bankName || ""}
                disabled
                className="ds-input bg-[var(--bg-app)] cursor-not-allowed"
              />
            </div>

            {/* ACCOUNT NUMBER */}
            <div className="flex flex-col">
              <label className="ds-label">
                ACCOUNT NUMBER <span className="text-[var(--error-color)]">*</span>
              </label>
              <input
                type="text"
                value={settalmentSingleAcc.accountNumber || ""}
                disabled
                className="ds-input bg-[var(--bg-app)] cursor-not-allowed"
              />
            </div>

            {/* IFSC */}
            <div className="flex flex-col">
              <label className="ds-label">
                IFSC CODE <span className="text-[var(--error-color)]">*</span>
              </label>
              <input
                type="text"
                value={settalmentSingleAcc.ifsc || ""}
                disabled
                className="ds-input bg-[var(--bg-app)] cursor-not-allowed"
              />
            </div>

            {/* TRANSACTION AMOUNT */}
            <div className="flex flex-col">
              <label className="ds-label">
                TRANSACTION AMOUNT <span className="text-[var(--error-color)]">*</span>
              </label>
              <input
                type="number"
                min="0"
                value={amount}
                onChange={handleChange}
                placeholder="Enter Amount to Transfer"
                className={`ds-input ${!amount ? "border-[var(--error-color)]" : ""}`}
              />
            </div>

            {/* TRANSFER MODE */}
            <div className="flex flex-col">
              <label className="ds-label">
                TRANSFER MODE <span className="text-[var(--error-color)]">*</span>
              </label>
              <select className="ds-input">
                <option>IMPS</option>
                <option>NEFT</option>
              </select>
            </div>

            {/* REMARKS */}
            <div className="flex flex-col md:col-span-2">
              <label className="ds-label">
                REMARKS
                 {/* <span className="text-[var(--error-color)]">*</span> */}
              </label>
              <textarea
                value={settalmentSingleAcc?.remarks || "Settlement"}
                placeholder="Your Remarks here..."
                className="ds-input h-24 resize-none bg-[var(--bg-app)] cursor-not-allowed"
                disabled
              />
            </div>
          </div>

          <div className="ds-form-actions">
            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading || !chargeLoaded}
              className="ds-btn ds-btn-primary"
            >
              {loading ? "Processing..." : !chargeLoaded ? "Loading charge..." : "Transfer"}
            </button>
            <button
              type="button"
              className="ds-btn ds-btn-secondary"
              onClick={() => navigate("/money-settlement")}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Main>
  );
};

export default MoneyTransfer;
